<script>
import BasicCard from '@/components/card-basic.vue'
import MaterialPriceCard from '@/components/makerlab-material-price-card.vue'
import PageHeader from '@/components/page-header.vue'
import PhoneButton from '@/components/button-phone'

export default {
  name: 'about-home',
  components: {
    BasicCard,
    MaterialPriceCard,
    PageHeader,
    PhoneButton,
  },
  data: () => ({
    chipItems: [
      {
        key: 2,
        icon: 'mdi-file-document',
        label: 'Info & Policies',
        slug: 'policies',
        value: 'policies',
      },
      {
        key: 1,
        icon: 'mdi-printer-3d',
        label: 'Equipment',
        slug: 'equipment',
        value: 'equipment',
      },
      {
        key: 3,
        icon: 'mdi-currency-usd',
        label: 'Materials & Pricing',
        slug: 'materials-pricing',
        value: 'materials-pricing',
      },
    ],
    chipItemSelected: null,
    equipment: [
      {
        details:
          'The Prusa i3 MK3S is a Fused Deposition Modelling (FDM) 3D printer that can print small parts quickly and cheaply while still offering a good resolution. This machine prints in PLA and PETG and is best suited for rapidly prototyping parts or for printing parts that will not undergo excessive amounts of stress or heat.',
        id: 5,
        img: 'https://media.eipl.org/site/images/pages/makerlab/prusa-3d-printer.png',
        title: '3D Printer Prusa MK3S',
      },
      {
        details:
          'A large, vibrant  75 inch 4K TV. The pefect display for learning, presentations and even gaming.',
        id: 7,
        img: 'https://media.eipl.org/site/images/pages/makerlab/samsung-tv.jpg',
        title: '4K 75" QLED HDTV',
      },
      {
        details:
          'The Cricut EasyPress 2 is a heat transfer tool that combines the speed of a heat press with the convenience of a home iron. Use it to apply iron-on/heat transfer vinyl (HTV), sublimation/Infusible Ink, or heat transfer paper designs to fabric items and sublimation blanks.',
        id: 3,
        img: 'https://media.eipl.org/site/images/pages/makerlab/cricut-easy-press-2.png',
        title: 'Cricut Easy Press 2',
      },
      {
        details:
          'The Cricut EasyPress Mini is a tool for  heat transfer Iron On, sublimation, HTV and Infusible Ink projects. The compact design will deliver high impact heat for applying heat transfer designs to unusually shaped items such as shoes and stuffed toys.',
        id: 2,
        img: 'https://media.eipl.org/site/images/pages/makerlab/cricut-easy-press-mini.png',
        title: 'Cricut Easy Press Mini',
      },
      {
        details:
          'The Cricut allows users to quickly and easily cut and engrave complex designs in a variety of materials. The Maker 3 works with over 300 different materials, including paper, cardstock, vinyl, and even leather! Cricut’s Design Space software makes it easy to create and import designs for use in countless art projects. ',
        id: 1,
        img: 'https://media.eipl.org/site/images/pages/makerlab/cricut-maker-3.png',
        title: 'Cricut Maker 3',
      },
      {
        details:
          "Give the gift of vibrant, professional-quality, personalized mugs with Cricut Mug Press. Just create your design using Cricut Infusible Ink materials, attach it to your mug, and let the press do the rest! With no manual temperature or pressure settings, it's easy to customize Infusible Ink compatible mugs with one-of-a-kind art or text.",
        id: 4,
        img: 'https://media.eipl.org/site/images/pages/makerlab/cricut-mug-press.png',
        title: 'Cricut Mug Press',
      },
      {
        details:
          "Retractable Chroma Green Background (6.9' x 9.9'). The chroma green color allows you to digitally cut in the background you need behind your subject. When properly lit, it gives you the freedom to superimpose the background that is perfect for your shot or interview.",
        id: 6,
        img: 'https://media.eipl.org/site/images/pages/makerlab/green-screen.png',
        title: 'Green Screen',
      },
    ],
  }),
  methods: {
    onChipChange(selected) {
      const chip = this.chipItems.find((c) => c.value === selected)
      if (!chip) {
        this.chipItemSelected = null
        return
      }
      if (this.$route?.params?.anchor !== chip.slug) {
        this.$router.push({
          name: 'maker-lab',
          params: {
            anchor: chip.slug || null,
          },
        })
      }
      const el = document.querySelector(`#${chip.slug}`)
      this.$nextTick(() =>
        el.scrollIntoView({ behavior: 'smooth', block: 'start' }),
      )
    },
  },
  mounted() {
    console.log('created')
    const slug = this.$route?.params?.anchor
    if (!slug) {
      this.chipItemSelected = null
      return
    }
    const chip = this.chipItems.find((c) => c.slug === slug)
    if (chip) {
      this.chipItemSelected = chip.value
      // this.onChipChange(chip.value)
      setTimeout(() => {
        this.onChipChange(chip.value)
      }, 500)
    }
  },
}
</script>

<template>
  <v-sheet height="100%" class="main-container">
    <v-img
      cover
      position="center center"
      src="https://media.eipl.org/site/images/pages/makerlab/makerlab-room-1.jpg"
      class="hero-image"
      :style="{
        height: `calc(100vh - ${$vuetify.application.top}px + 100px)`,
        top: '50px',
      }"
    ></v-img>
    <page-header
      v-model="chipItemSelected"
      :autoHide="false"
      backgroundColor="#aea096"
      :chipItems="chipItems"
      titleText="MAKER LAB"
      :titleColor="$vuetify.theme.themes.light.primary"
      @input="onChipChange"
    ></page-header>
    <v-container fluid class="d-flex flex-column transparent align-center px-4">
      <v-row align="start" align-contet="center" justify="center">
        <v-col
          id="policies"
          cols="12"
          md="10"
          lg="7"
          class="d-flex flex-column align-center justify-center pt-0 mb-10"
          style="margin-top: 34vh"
        >
          <v-card rounded="lg" width="100%" class="mt-16">
            <!-- <v-card-title>
            <h2 class="text-h5 purple--text font-weight-bold text-center" style="word-break: break-word">1000 Books before Kindergarten</h2>
          </v-card-title> -->
            <v-card-text>
              <v-sheet
                class="d-flex flex-row flex-wrap align-center align-sm-start justify-space-around"
              >
                <p class="text-h4 blue--text font-weight-bold mb-0 mx-1 mt-4">
                  INVENT
                </p>
                <p class="text-h4 green--text font-weight-bold mb-0 mx-1 mt-4">
                  BUILD
                </p>
                <p class="text-h4 orange--text font-weight-bold mb-0 mx-1 mt-4">
                  SHARE
                </p>
              </v-sheet>
              <p class="text-h6 primary--text mt-14">
                The East Islip Public Library (EIPL) Maker Lab is an innovative,
                creative space that provides library patrons with equipment and
                software to create personal projects, learn new skills, and
                explore their interests.
              </p>
              <p class="text-body-1 primary--text mt-5">
                Use of the Maker Lab is reserved for EIPL patrons with a library
                card in good standing.
                <br />
                Drop-in visits are allowed but are subject to staff
                availability, appointments, and scheduled programs.
                <br />
                Appointments to use the equipment are recommended and can be
                made by visiting or calling the reference desk (631-581-9200
                ext. 5).
              </p>
              <!-- <p class="text-body-2 primary--text mt-12">The Maker Lab's full policy can be viewed below.</p> -->
            </v-card-text>
            <v-card-actions class="d-flex flex-wrap justify-space-between">
              <phone-button class="ma-2"></phone-button>

              <v-btn color="primary" class="ma-2"
                ><v-icon>mdi-file-document</v-icon>MAKER LAB POLICY</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="10"
          lg="7"
          xl="8"
          class="d-flex justify-center mt-10"
        >
          <v-card id="equipment" width="100%">
            <v-card-title
              class="primary secondary--text text-h5 font-weight-bold break-word"
              >EQUIPMENT</v-card-title
            >
            <v-card-text class="primary--text">
              <p class="text-h6 primary--text px-8 my-12">
                The EIPL Maker Lab provides the tools, equipment, and training
                that allow people to create all kinds of projects.
                <br />
                See some of the available equipment below.
              </p>
              <v-sheet class="pb-10 mx-auto">
                <basic-card
                  v-for="item in equipment"
                  :key="item.id"
                  :item="item"
                  class="mt-4"
                ></basic-card>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          id="materials-pricing"
          cols="12"
          md="10"
          lg="7"
          xl="8"
          class="d-flex justify-center mt-10"
        >
          <material-price-card />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>
<style scoped>
.main-container {
  /* --background: #ff9800;
    background-color: var(--background); 
    */
  background-color: #aea096;
}
.hero-image {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  /* opacity: 0.8; */
  z-index: 0;
}
.hero-image :before {
  content: '';
  background-image: linear-gradient(to top, #aea096, rgba(239, 239, 239, 0));
  position: absolute;
  height: 100px;
  right: 0;
  bottom: 0;
  left: 0;
}
.content-container {
  position: relative;
  z-index: 1;
}

.mission-statement {
  margin-block: 12vh;
  border: 1px solid var(--v-primary-base) !important;
}
</style>
